import axios from 'axios';


export const  axios_gestion_getchamps = async (courtier)=>{
    return  await axios.post(`/gestion/getchamps`,{'courtier':courtier});
}

export const  axios_gestion_getcommerciaux = async ()=>{
    return  await  axios.get(`/gestion/getcommerciaux`,{headers:{'Accept':'application/json'} });

}

export const  axios_gestion_getallfomulesempty = async ()=>{
    return  await axios.get(`/gestion/getallfomulesempty`,{headers:{'Accept':'application/json'} });

}

export const  axios_gestion_alertcontratchangestatut = async (lead,gestionname)=>{
    return  await axios.post(  `/gestion/alertcontratchangestatut/`,{lead,gestionname});

}

export const  axios_gestion_getdataleads = async (multiselect)=>{
    return  await axios.post(`/gestion/getdataleads`,{...multiselect });
}


 // A RETIRER ????
export const  axios_gestion_getenterfauxnum = async (jsondata)=>{
    return  await axios.post(`/gestion/getenterfauxnum`,jsondata);
}

let actucontroller = null;
export const  axios_gestion_searchleadsfxnumeros = async ({debut,fin,typedate})=>{
    actucontroller && actucontroller.abort() ;
    const controller = new AbortController();
    actucontroller = controller ;
    return  await axios.post(`/gestion/searchleadsfxnumeros`,{debut,fin,typedate},{signal: controller.signal},{headers:{'Accept':'application/json'} });
}


export const  axios_gestion_fauxnumero = async ({email,telephone,date_origine,courtier,origine,campagne,commercial})=>{
    return  await axios.post(`/gestion/fauxnumero`,{email,telephone,date_origine,courtier,origine,campagne,commercial}) 
}


export const  axios_gestion_getcommissions= async ()=>{
    return  await axios.get(`/gestion/getcommissions`) 
}


export const  axios_gestion_updatecommission= async ({id,prix})=>{
    return  await axios.post(`/gestion/updatecommission`,{id,prix}) 
}


export const  axios_gestion_createcommission= async (data)=>{
    return  await axios.post(`/gestion/createcommission`,data) 
}



